var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4998 15.3694V17.5594C23.4998 19.9994 21.7198 22.2994 19.2998 22.9694C19.1298 23.0094 18.9499 23.0094 18.7899 22.9694C17.6099 22.6494 16.5698 21.9295 15.8398 20.9995C15.0498 20.0195 14.5898 18.8094 14.5898 17.5594V15.3694C14.5898 14.9494 14.8998 14.4895 15.2798 14.3295L18.0598 13.1895C18.6898 12.9395 19.3898 12.9395 20.0198 13.1895L21.0198 13.5994L22.8098 14.3295C23.1898 14.4895 23.4998 14.9494 23.4998 15.3694Z",
    fill: "#A1BAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.4503 11.0093L21.0203 13.5993L20.0203 13.1893C19.3903 12.9393 18.6903 12.9393 18.0603 13.1893L15.2803 14.3293C14.9003 14.4893 14.5903 14.9493 14.5903 15.3693V17.5593C14.5903 18.8093 15.0503 20.0193 15.8403 20.9993H6.68027C5.31027 20.9993 4.02029 19.9093 3.79029 18.5593L2.53028 11.0093C2.37028 10.0793 2.84027 8.82931 3.58027 8.23931L10.1603 2.9793C11.1703 2.1693 12.8103 2.16931 13.8203 2.98931L20.4003 8.23931C21.1303 8.82931 21.6103 10.0793 21.4503 11.0093Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.8eb40d74314b189b3aa88fc8b9e57dca.svg";
export { ForwardRef as ReactComponent };